import $ from "jquery";
import "video.js";

window.jQuery = window.$ = $;

require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/dropdown');
require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse');
require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition');
require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal');

require('../../node_modules/select2/dist/js/select2.full');
require('../../node_modules/select2/dist/js/i18n/de');

require('../../node_modules/bootstrap-fileinput/js/plugins/sortable');
require('../../node_modules/bootstrap-fileinput/js/fileinput');
require('../../node_modules/bootstrap-fileinput/themes/fa/theme');
require('../../node_modules/bootstrap-fileinput/js/locales/de');

require('../../bower_components/slick-carousel/slick/slick');

;(function (window, document) {
  const App = require('../_scripts/App');

  App.Api = require('../_scripts/App/Api');
  App.BoxSlider = require('../_scripts/App/BoxSlider');
  App.ReportMap = require('../_scripts/App/ReportMap');
  App.ReportList = require('../_scripts/App/ReportList');
  App.GoogleMap = require('../_scripts/App/GoogleMap');
  App.SocialShare = require('../_scripts/App/SocialShare');
  App.Dictionary = require('../_scripts/App/Dictionary');

  window.App = App;

  const initialize = function () {
    $(document).ready(() => {
      App.initialize();
      App.BoxSlider.initialize('.slick-container', '.slick-slider');
      App.GoogleMap.initialize('#google-map');
      App.ReportMap.initialize('#google-map-report');
      App.SocialShare.initialize('.social-share', '.menu');
      App.ReportList.initialize('#status_id');
      App.Dictionary.initialize('#content');

      const $fontSizeSelection = $('.font-size-selection');
      if ($fontSizeSelection.length) {
        $fontSizeSelection.find('a').click(function () {
          const $el = $(this);
          const $parent = $el.parent();
          $fontSizeSelection.find('li').removeClass('active');
          $parent.addClass('active');
          $('html').css('font-size', parseInt($el.css('font-size'), 10) + 2 + 'px');
        });
      }
    });
  };

  let loadedInterval = setInterval(function () {
    if (typeof window.google !== 'undefined') {
      clearInterval(loadedInterval);
      initialize();
    }
  }, 100);
}(window, document));
